import moment from 'moment';

export function isValidDate(date?: Date | string | null) {
    if (!date) {
        return false;
    }

    return moment(date).isValid();
}
